import { Component, Output, EventEmitter } from "@angular/core";
import { Proxy } from "../../services/proxy/proxy.service";
import { APIOnLine } from "../../services/api/api.services";
import { PaginaBasica } from "../../models/PaginaBase";
import { LoadingController, ToastController } from "ionic-angular";
import { NgForm } from "@angular/forms/src/directives/ng_form";

@Component({
  selector: "resultado-parcial",
  templateUrl: "resultado-parcial.html",
})
export class ResultadoParcialComponent extends PaginaBasica {
  @Output() actualizacion = new EventEmitter<boolean>(); // Evento para indicar que se ha actualizado el resultado parcial

  // #region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  // #endregion

  constructor(
    public Persistentes: APIOnLine.Persistentes,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  /**
   * Inicialización del componente
   */
  ngOnInit() {
    this.designacion = this.Persistentes.GetDesignacion();
  }

  // #region Métodos del controlador

  public ActualizarResultado(form: NgForm): void {
    if (form.valid) {
      this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
      this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

      this.designacion.OtrosDatos.Guardar()
        .then((resultado: boolean) => {
          this.Mensaje(
            "Se ha actualizado el resultado parcial del encuentro.",
            5000
          );
          this.actualizacion.emit(true);
        })
        .catch((error) =>
          this.Error(error, "ERROR actualizando el resultado parcial del acta.")
        );
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/resultado-parcial/resultado-parcial.ts